var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTicketsScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000117889 7.70004V6.30004H14.0001V7.70004H0.000117889ZM9.80012 14V13H12.9995V9.80004H14.0001V12.6C14.0001 12.7275 14.0001 12.8613 14 13C13.9997 13.5523 13.5518 14 12.9995 14C12.9015 14 12.8105 14 12.7274 14H9.80012ZM4.20012 14H1.27285C1.1816 14 1.09096 14 0.999233 14C0.447071 14 -0.000443583 13.5524 -6.59159e-05 13.0002C3.68765e-05 12.8499 0.000117889 12.7133 0.000117889 12.6V9.80004H0.999973V13H4.20012V14ZM9.80012 4.2595e-05H12.7274C12.8163 4.2595e-05 12.9069 4.01533e-05 13.0001 3.78043e-05C13.5523 2.38977e-05 14 0.447761 14.0001 0.999968C14.0001 1.14648 14.0001 1.28215 14.0001 1.40004V4.20004H13V1H9.80012V4.2595e-05ZM4.20012 4.2595e-05V1.00004H1.00012V4.20004H0.000117889V1.00004C0.000117889 0.447758 0.447833 -4.44054e-06 1.00012 4.2595e-05H4.20012Z",
    fill: "#B1C2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5V10.4C4 10.4552 4.04477 10.5 4.1 10.5H9.9C9.95523 10.5 10 10.4552 10 10.4V8.5",
    stroke: "#B1C2CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5V3.6C4 3.54477 4.04477 3.5 4.1 3.5H9.9C9.95523 3.5 10 3.54477 10 3.6V6.5",
    stroke: "#B1C2CF",
    strokeMiterlimit: 16
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsScan);
export default __webpack_public_path__ + "static/media/tickets-scan.a389d1cd6df9e74fc4c15722a1260ef3.svg";
export { ForwardRef as ReactComponent };